import axios from "axios";
import Cookie from "js-cookie";
import appUrls from '../../../helpers/environment';

export default {
    methods: {
        async deleteFile (item) {
            // Add logic to handle deleting of uploaded files here
            await axios.put(`${appUrls.api}/api/rm_uploaded_file`, {
                headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                file_data: item
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/questionnaire_template/mixins/data-table-file-mixins.js